module.exports = __webpack_public_path__ + "static/VCB-Huong-679f57ced2fc6d7dda58fe9fa05825d2.jpg";